let originCart = false;

// handling Enter keypress on Quickview div
function handleQuickClick(event) {
  const cartCont = document.querySelector('.crtmodlsld.active');

  if (event.key == 'Enter') {
    cartCont ? originCart = true : originCart = false;
    event.target.click();
  }
}

/////////////////////////////////////////
// Judgeme Reply truncate
document.addEventListener('DOMContentLoaded', function() {
  var replyElement = document.querySelector('.jdgm-rev__reply');
  if (replyElement) {
  var replyText = replyElement.textContent;
  var maxLength = 200; // Maximum length of the reply text
  if (replyText.length > maxLength) {
  replyText = replyText.substring(0, maxLength) + '...';
  replyElement.textContent = replyText;
  }
 }
  });
  
var count = 0;
var textforreadmore = "Read more";
window.addEventListener('scroll', (event) => {
function Shrinkss() {
document.querySelectorAll(".jdgm-rev__reply-content").forEach(function(shrinkables){
if (shrinkables.innerHTML.indexOf(textforreadmore) == -1) {
count+=1;
shrinkables.setAttribute("id","reply-"+count);
shrinkables.classList.add("line-clams");
shrinkables.innerHTML += "<span id='"+count+"MoreLink'><a onclick='showMore("+count+")' style='cursor: pointer;'>"+textforreadmore+"</a></span>";
}
})
}
Shrinkss()
document.addEventListener('click',function() {
setTimeout(function(){ Shrinkss() }, 200);
})
})
function showMore(id){
document.getElementById('reply-'+id).className='';
document.getElementById(id+'MoreLink').className='hiddenss';
}
/////////////////////////////////////////
// QUICKSHOP MODAL KEYBOARD ACCESSIBILITY
/////////////////////////////////////////
// keyboard accessibility requires a modal to be focused when opened,
// trapping focus within the modal when tab or shift + tab keys are pressed,
// and closing the modal when ESC is pressed
// select variant on Enter
function selectVariantOpt(event, elem) {
  if (event.key == 'Enter') {
    elem.previousElementSibling.click();
    quickviewOpened();
  }
}

function quickviewOpened(prodid) {
  const modalCont = document.querySelector('.modal.active');
  const activeModal = document.querySelector('.modal.active .quickshop');
  
  // if there isn't an active modal, bounce
  if(!activeModal){ return; }

  // wait for elements to load
  setTimeout(function() {
    if (activeModal) {
      const modalCloseBtn = document.querySelector('.modal.active button.focuselems');
      const sizesel = document.querySelector('.modal.active .quickshop fieldset');
      const returnFocus = document.querySelector('#' + prodid + '.QuickView__button');
      const cartReturnFocus = document.querySelector('.cartswiperwrapper #' + prodid + '.QuickView__button');
      const dropoptions = document.querySelector('.modal.active .quickshop .optionscont');
      const cartBtn = document.querySelector('.headcartbtn');

      sizesel.focus();

      sizesel.addEventListener('keyup', function(event) {
        if (event.key == 'Enter') {
          dropoptions.style.display = 'block';
        }
      });

      dropoptions.addEventListener('focusout', function() {
        dropoptions.style.display = '';
      });
    
      modalCont.addEventListener('keydown', function(event) {
        const tabKey = event.key == 'Tab';
        const escKey = event.key == 'Escape';

        // trap focus in modal when tab or shift + tab is pressed
        if (event.shiftKey && tabKey) {
          if (document.activeElement === sizesel) {
            modalCloseBtn.focus();
            event.preventDefault();
          }
        }
        
        if (tabKey && !event.shiftKey) {
          if (document.activeElement === modalCloseBtn) {
            sizesel.focus();
            event.preventDefault();
          }
        }

        // closing modal with ESC key and returning focus to quickview button used to open the modal
        if (escKey) {
          modalCont.classList.remove('active');
          document.querySelector('html').removeAttribute('data-active-modal');
          if (originCart == true) {
            setTimeout(function() {
              cartBtn.click();
              if (cartReturnFocus) {
                cartReturnFocus.focus();
              }
            }, 700)
          } else {
            if (returnFocus) {
              returnFocus.focus();
            }
          }
        }
      });
    }
  }, 1000);
}
